import { Modal, notification, PDFDocumentView, Button } from "components/common"
import Flex from "components/common/flex"
import { LOGIN_PATH } from "constants/app-paths"
import { lowPerformanceDocumentTitles } from "constants/list"
import { useLogoutMutation } from "features/auth/api"
import { documentTypes } from "features/inventory/data/constants"
import { useLazyGetLowPerformanceWarningDocumentQuery, useSignLowPerformanceWarningDocumentMutation } from "features/shared/api"
import { t } from "i18next"
import { forwardRef, useImperativeHandle, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"

const LowPerformanceWarningModal = forwardRef((_props, ref) => {
  const navigate = useNavigate()
  const [userId, setUserId] = useState()
  const [title, setTitle] = useState()
  const [document, setDocument] = useState() 
  const [getReport, { data, error, isLoading }] = useLazyGetLowPerformanceWarningDocumentQuery()
  const [signReport, { isLoading: isLoadingSign, error: errorSign }] = useSignLowPerformanceWarningDocumentMutation()
  const [logoutUser, { isLoading: isLoadingLogout }] = useLogoutMutation()
  const modalRef = useRef()
  const confirmModalRef = useRef()

  useImperativeHandle(
      ref,
      () => ({
        showFor(data) {
          setUserId(data?.userId)
          setDocument(data?.document)
          setTitle(lowPerformanceDocumentTitles()[data?.document?.type])
          getReport({ documentId: data?.document?.id, type: data?.document?.type, useBuffer: true })
          modalRef.current.setVisible(true)
        },
      }),
      []
    )

    const onConfirm = () => {
      signReport({ userId, documentId: document?.id })
        .unwrap()
        .then(() => {
          confirmModalRef?.current?.setVisible(false);
          modalRef?.current?.setVisible(false)
        })
        .catch(error => {
          notification.error({ message: error?.message});
        });
    }
  
    const handleLogout = () => {
      logoutUser({}).then(e => {
        modalRef?.current?.setVisible(false)
        navigate(LOGIN_PATH)
      })
    }

    return (
        <>
          <Modal
            ref={modalRef}
            closable={false}
            bodyStyle={{ padding: 24 }}
            destroyOnClose
            title={title}
            footer={
              !isLoading && (
                <Flex justify="space-between">
                  <div>
                    <Button type="primary-light" loading={isLoadingLogout} size="large" key="logout" onClick={handleLogout}>
                      {t("Logout")}
                    </Button>
                  </div>
                  <div>
                    <Button
                      size="large"
                      key="continue"
                      type="primary"
                      onClick={() => confirmModalRef?.current?.setVisible(true)}
                      disabled={error}
                    >
                      {t("Acknowledge")}
                    </Button>
                  </div>
                </Flex>
              )
            }
          >
            <PDFDocumentView
              error={error}
              isLoading={isLoading}
              data={data}
              onRefetch={() => getReport({ documentId: document?.id, type: document?.type, useBuffer: true })}
            />
          </Modal>
          <Modal
            width={450}
            ref={confirmModalRef}
            onCancel={() => confirmModalRef?.current?.setVisible(false)}
            bodyStyle={{ padding: 24 }}
            onOk={onConfirm}
            okText={t("Proceed")}
            destroyOnClose
            title={t("Confirmation")}
            loading={isLoadingSign}
          >
            {t("Are you sure you have read and want to sign the document?")}{" "}
          </Modal>
        </>
      )
})

export default LowPerformanceWarningModal